<script lang="ts">
  import CustomerCard from "../components/cards/CustomerCard.svelte";
  import ProjectGrid from "../components/content/project/ProjectGrid.svelte";
  import { Skeleton } from "flowbite-svelte";
  import { getCustomer } from "../services/api/data-handler.js";
  import type { Customer } from "../services/api/types.js";
  import { Splitpanes, Pane } from "svelte-splitpanes";

  export let id: string; // needs to be id, because main.svelte uses id for the route
  let customer: Customer | undefined;
  let splitPosition: number = 15;

  $: if (id) {
    getCustomer(id).then((result) => {
      customer = result.customer;
    });
  }
</script>

{#if customer}
  <div class="customer-overview">
    <Splitpanes class=" -splitpanes" horizontal={false}>
      <Pane size={splitPosition} minSize={10} maxSize={40}>
        <!-- Customer Card -->
        <div class="app-card customer-card-pane">
          <CustomerCard {customer} />
        </div>
      </Pane>
      <Pane size={100 - splitPosition}>
        <!-- Right Panel Content -->
        <div class="customer-content-pane">
          <div class="component-content app-grid inside-object">
            <ProjectGrid customer_id={id} />
          </div>
        </div>
      </Pane>
    </Splitpanes>
  </div>
{:else}
  <Skeleton size="sm" divClass="my-8" />
{/if}
